$color = $('.brand-colors .rectangles .color, .brand-colors .rectangles-slim .color');

$color.mousemove(function(e) {
    var $target = $(e.target);
    var targetOffset = $target.offset();
    var scrollY = window.scrollY;

    var clientX = e.clientX - targetOffset.left;
    var clientY = e.clientY - targetOffset.top + scrollY;

    var $tooltip = $target.find('.tooltip-text');
    $tooltip.css({left: clientX + 'px', top: clientY + 'px'});
});

$color.click(function(e) {
    e.preventDefault();
    var $this = $(this);

    var hex = $this.data('hex');

    if (hex) {
        const el = document.createElement('textarea');
        el.value = hex;
        document.body.appendChild(el);
        el.select();
        document.execCommand('copy');
        document.body.removeChild(el);

        var $tooltipText = $this.find('.tooltip-text');
        $tooltipText.html('Copied HEX.');

        setTimeout(function() {
            $tooltipText.html('Copy HEX to clipboard');
        }, 2000);
    }
})
